import { Component, ElementRef, Input, OnInit, SimpleChange, ViewChild } from '@angular/core';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { GlobalConstants } from '../../../../../app/common/constants/global.constant';
import { LivePreview } from './../../../interfaces/live-preview.i';
import { CommonService } from '../../../../common/services/common.service';

@Component({
  selector: 'iposcen-mini-live-preview',
  templateUrl: './mini-live-preview.component.html',
  styleUrls: ['./mini-live-preview.component.scss']
})
export class MiniLivePreviewComponent implements OnInit {
  previewData: LivePreview;
  isListPreview: boolean;
  headingLabel: string;
  bodyLabel: string;
  FILE_TYPE_IMAGE: string = GlobalConstants.FILE_TYPE_IMAGE;
  FILE_TYPE_VIDEO: string = GlobalConstants.FILE_TYPE_VIDEO;
  @ViewChild('preview1') bodyPreview1: ElementRef;
  @ViewChild('preview2') bodyPreview2: ElementRef;
  @ViewChild('preview3') bodyPreview3: ElementRef;
  animateFlag: boolean = false;
  private ngUnsubscribe = new Subject<boolean>();
  constructor(private cmnSer: CommonService) {}
  @Input() data;
  @Input() isIdleExperienceEnable: string;
  activeCustomClass = false;
  smallText = false;
  largeText = false;
  MediumText = false;
  isIdleExp: string;
  previewTypes:string;
  globConst = GlobalConstants;

  ngOnInit(): void {
    this.headingLabel = $localize`:@@page.heading-label:HEADING`;
    this.bodyLabel = $localize`:@@page.body-label.name:Body`;
    // passing default values
    this.previewData = {
      bgcolor: '#0068B5',
      heading: this.headingLabel,
      hcolor: '#ffffff',
      body: this.bodyLabel,
      size: 'Medium',
      media: {
        name: '',
        url: '',
        format: '',
      },
      layout: 1,
      bcolor: '#ffffff',
      previewType: GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS,
      idleExpFullscreenEnabled: false
    };
    try{
      this.previewData = JSON.parse(JSON.stringify(this.data));
    }
    catch(e){
      console.log(e);
    }
    this.cmnSer.emitNavBtnClickObser
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe((data) => {
      this.animateFlag = data;
    });

    this.previewTypes = GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS;
  }

  ngOnChanges(changes: { [property: string]: SimpleChange }) {
    if(changes.isIdleExperienceEnable) {
      this.isIdleExp = changes.isIdleExperienceEnable.currentValue;
    }
}
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  //Font-size according to data
  fontSize(size) {
    if (size === GlobalConstants.SMALL) {
      return GlobalConstants.FONTSIZE_12PX;
    }
    if (size === GlobalConstants.MEDIUM) {
      return GlobalConstants.FONTSIZE_14PX;
    }
    if (size === GlobalConstants.LARGE) {
      return GlobalConstants.FONTSIZE_16PX;
    }
  }
}
